import React from "react";
import { Skeleton } from "@material-ui/lab";
import { NonNullableItemState } from "../../redux/state";
import { ScrollableAreaTabs as CoreScrollableAreaTabs } from "@ofqual/portal-components/components/ScrollableAreaTabs";
import { CaoActivityFeed } from "../tabs/activityfeed/CaoActivityFeed";
import { Actions } from "../tabs/actions/Actions";
import { NoticeTabHeading } from "../tabs/actions/notice/NoticeTabHeading";
import { useActionsState } from "../../hooks/useActionsState";
import { useValidation } from "../../hooks/useValidation";
import { RecipientOrg } from "../../domain/RecipientsViewModel";

export const CaoScrollableAreaTabs: React.FC<{
  informationRequestId: string;
  recipientOrg: RecipientOrg | null;
  itemId: string;
  itemState: NonNullableItemState | null;
}> = ({ itemState, informationRequestId, recipientOrg, itemId }) => {
  const { isReady, isActionsOk } = useValidation();
  const shouldShowWarning = isReady && !isActionsOk;

  const actionsState = useActionsState(informationRequestId, itemId);

  return itemState ? (
    <CoreScrollableAreaTabs
      twelfths={6}
      dataTest="activity-tabs"
      defaultTabIx={1}
      tabs={[
        {
          label: shouldShowWarning ? (
            <NoticeTabHeading>Actions</NoticeTabHeading>
          ) : (
            "Actions"
          ),
          content: (
            <Actions
              actionsState={actionsState}
              disabled={recipientOrg?.closed}
              organisationRecipientId={recipientOrg?.organisationRecipientId!}
              itemId={itemId}
            />
          ),
        },
        {
          label: "Activity",
          content: (
            <CaoActivityFeed
              informationRequest={itemState.item}
              resourceId={recipientOrg?.organisationRecipientId!}
              itemId={itemId}
              disabled={recipientOrg?.closed}
            />
          ),
        },
      ]}
    ></CoreScrollableAreaTabs>
  ) : (
    <>
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
      <br />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
    </>
  );
};
